/*
 *
 * DataRow
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 14-Oct-2024
*/

import DataRow from './DataRowContainer'

export default DataRow
